import { useState } from 'react'
import {
	AlertIcon,
	CrossIcon,
	DarkModeIcon,
	DownloadIcon,
	EmptyBigBoxIcon,
	UploadProfilePictureIcon,
} from '../icons'
import { Modal } from '../util'

export const Settings: React.FC = () => {
	const [photo, setPhoto] = useState({
		imgURL: '',
	})

	const [open, setOpen] = useState<boolean>(false)
	const [openCardNumberPopUp, setOpenCardNumberPopUp] = useState<boolean>(false)

	const onChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
		console.log(e.currentTarget.files)
		const file = e.currentTarget.files && e.currentTarget.files[0]
		const photoNewObj = Object.assign(file, {
			imgURL: URL.createObjectURL(file),
		})
		setPhoto(photoNewObj)
	}

	return (
		<div className='settings'>
			<div className='rows'>
				<div className='first-row'>
					<section className='content'>
						<h1>Settings</h1>
						<p>Manage your account details, billing information and package.</p>
					</section>
					<img src='./settings-image.png' alt='settingsimage' />
				</div>
				<div className='second-row'>
					<section className='header'>
						<h3>General Settings</h3>
						<p>Manage your login details and password.</p>
					</section>
					<section className='cards-grid'>
						<section className='profile-picture'>
							<section>
								{photo.imgURL ? (
									<div className='upload-image-section'>
										<img src={photo.imgURL} alt='imag' />
										<div>
											<CrossIcon onClick={() => setPhoto({ imgURL: '' })} />
										</div>
									</div>
								) : (
									<label
										className='upload-image-section'
										htmlFor='upload-photo'>
										<UploadProfilePictureIcon />
										{/* <DragAndDropCloudIcon /> */}
									</label>
								)}
								<input
									type='file'
									accept='image/*'
									onChange={onChangeHandler}
									id='upload-photo'
								/>
							</section>
							<section className='content'>
								<section className='texts'>
									<h3>Profile Picture</h3>
									<p>Click on the circle to upload your profile picture.</p>
								</section>
								<section className='button-section'>
									<button>Upload & Save</button>
								</section>
							</section>
						</section>
						<section className='dark-mode'>
							<DarkModeIcon />
							<section className='content'>
								<section className='texts'>
									<h3>Dark Mode</h3>
									<p>You can active night mode to be more relaxed.</p>
								</section>
								<section className='button-section'>
									<button>Coming soon</button>
								</section>
							</section>
						</section>
						<section className='personal-info'>
							<section className='texts'>
								<h3>Chance Personal Information</h3>
								<p>
									If you change email address, make sure to confirm the one
									after.
								</p>
							</section>
							<section className='inputs-section'>
								<input type='text' placeholder='Full Name' />
								<input type='email' placeholder='Email' />
							</section>
							<section className='button-section'>
								<button>Update Information</button>
							</section>
						</section>
						<section className='change-password'>
							<section className='texts'>
								<h3>Change Password</h3>
								<p>On your next login, you will be using this new password.</p>
							</section>
							<section className='inputs-section'>
								<input type='text' placeholder='New Password' />
								<input type='email' placeholder='Confirm New Password' />
							</section>
							<section className='button-section'>
								<button onClick={() => setOpen(true)}>Update Password</button>
							</section>
							<Modal open={open} onClick={() => setOpen(false)}>
								<section className='update-password-popup'>
									<AlertIcon />
									<h1>Updating Your Password</h1>
									<p>
										Please confirm your current password in order to update your
										password.
									</p>
									<input
										type='text'
										placeholder='Confirm your current password'
									/>
									<section className='button-section'>
										<button>UPDATE PASSWORD</button>
									</section>
								</section>
							</Modal>
						</section>
					</section>
				</div>
				<div className='third-row'>
					<section className='header'>
						<h3>Billing Settings</h3>
						<p>Manage your login details and password.</p>
					</section>
					<section className='cards-grid'>
						<section className='billing-info'>
							<section className='texts'>
								<h3>Billing Information</h3>
								<p>
									You can change your billing information in the field below.
								</p>
							</section>
							<section className='inputs-section'>
								<input type='text' placeholder='Full Name' />
								<input type='email' placeholder='Email' />
								<input type='text' placeholder='Company (Optional)' />
								<input type='text' placeholder='Enter Your VAT Number' />
							</section>
							<section className='texts2'>
								<h3>Card Information</h3>
								<p>You can change your card information in the field below.</p>
							</section>
							<section className='card-number'>
								<input type='text' placeholder='**** **** **** 5012' />
								<button onClick={() => setOpenCardNumberPopUp(true)}>
									Change Card
								</button>
							</section>
							<section className='button-section'>
								<button>Save Changes</button>
							</section>
							<Modal
								open={openCardNumberPopUp}
								onClick={() => setOpenCardNumberPopUp(false)}>
								<section className='card-number-popup'>
									<AlertIcon />
									<h1>Change Card</h1>
									<p>You are changing your payment method.</p>
									<input type='text' placeholder='Company Name (Optional)' />
									<input type='text' placeholder='Card Holder Full Name *' />
									<section className='card-number-requirements'>
										<input type='text' placeholder='Card Number *' />
										<input type='text' placeholder='MM / YY   CVC' />
									</section>
									<section className='button-section'>
										<button>UPDATE card ınformatıon</button>
									</section>
								</section>
							</Modal>
						</section>

						<section className='upcoming-invoice'>
							<section className='texts'>
								<h3>Upcoming Invoice</h3>
								<p>This is a preview of the invoice that will be billed.</p>
							</section>
							{upcomingInvoice.length !== 0 ? (
								<section className='data-table'>
									{upcomingInvoice.map((item, i) => (
										<section className='data-table-row'>
											<h5>{item.title}</h5>
											<h5>${item.price}</h5>
											<DownloadIcon />
										</section>
									))}
								</section>
							) : (
								<section className='data-table-null'>
									<section className='no-upcoming-invoices'>
										<p>You do not have an invoice yet.</p>
										<EmptyBigBoxIcon />
									</section>
								</section>
							)}
						</section>
					</section>
				</div>
			</div>
		</div>
	)
}

const upcomingInvoice: {
	title: string
	price: string
}[] = [
	{
		title: 'January Invoice',
		price: '40.00',
	},
	{
		title: 'January Invoice',
		price: '40.00',
	},
	{
		title: 'January Invoice',
		price: '40.00',
	},
	{
		title: 'January Invoice',
		price: '40.00',
	},
	{
		title: 'January Invoice',
		price: '40.00',
	},
	{
		title: 'January Invoice',
		price: '40.00',
	},
	{
		title: 'January Invoice',
		price: '40.00',
	},
	{
		title: 'January Invoice',
		price: '40.00',
	},
]
